import React from 'react';
import {ActionButtonWrapper, Banner, Headline, Sub} from './styles';
import {ContentContainer, MenuStyled} from '../styles';
import Link from 'next/link';
import ActionButton from '../../components/ActionButton';
import {assetUrl} from '../index';


const SubTextLine = () => (
	<Sub>
		<img src={assetUrl('note.png')}/>
		<span>
			Cẩm nang nghề giúp Newbie vững thế khi tìm việc
		</span>
	</Sub>
)

interface IMenu
{
	label: string,
	url: string,
	newTab?: boolean
}

interface IParentMenu extends IMenu
{
	child?: IMenu[]
}

const menuList: IParentMenu[] = [
	{
		label: 'Tìm việc thông minh',
		url: '#tim-viec-thong-minh',
	},
	{
		label: 'Hiểu mình yêu nghề',
		url: '#hieu-minh-yeu-nghe',
		child: [
			{
				label: 'Tra cứu Nhân số học',
				url: '#hieu-minh-yeu-nghe',
			},
			{
				label: 'Tra cứu Lộ trình sự nghiệp',
				url: '#hieu-minh-yeu-nghe',
			},
		]
	},
	{
		label: 'Trạm sạc kỹ năng',
		url: '#podcast-danh-cho-fresher',
		child: [
			{
				label: 'Podcast dành cho Fresher',
				url: '#podcast-danh-cho-fresher'
			},
			{
				label: 'Blog hành trang Fresher',
				url: '#blog-hanh-trang-fresher'
			}
		]
	}, {
		label: 'Đồng hành cùng Top University',
		url: '#top-university'
	}
]

function onMenuClick(e, item) {
	if (!item.url.startsWith('#')) {
		return
	}
	const target = document.querySelector(item.url)
	if (!target) {
		return
	}
	e.preventDefault()
	scrollToElm(target)
}

function scrollToElm(target) {
	window.scrollTo({
		top: target.getBoundingClientRect().top + window.scrollY - 100,
		behavior: 'smooth'
	})
}
const MenuItem = ({item}: { item: IMenu | IParentMenu }) => <li>
	<a className={(item as IParentMenu).child ? 'parent' : ''} href={item.url.startsWith('#') ? item.url : `${item.url}?utm_source=webVNW&utm_medium=Traffic&utm_campaign=Entry2023`}
	   onClick={(e) => onMenuClick(e, item)}
	   target={item.newTab ? "_blank" : "_self"}>
		{item.label}
	</a>
</li>
const Menu = () => <MenuStyled>
	{menuList.map(parentMenu => <ul key={parentMenu.url}>
		<MenuItem item={parentMenu}/>
		{
			(parentMenu.child || []).map(childMenuItem => <MenuItem key={childMenuItem.url} item={childMenuItem}/>)
		}
	</ul>)}
</MenuStyled>

const FindJobButton = () => (<ActionButtonWrapper>
	<ActionButton href='#viec-lam-entry-section' onClick={(e) => onMenuClick(e, {url: '#viec-lam-entry-section'})} variant="orange">
		Tìm việc làm
	</ActionButton>
</ActionButtonWrapper>)

const HeroBanner = () => (
	<Banner.Wrapper>
		
		<Menu/>
		
		<Banner.City>
			<img src={assetUrl('city.png')}/>
		</Banner.City>
		
		<Banner.Content>
			
			<Headline>
				Định tương lai<br/><span>Guide sự nghiệp</span>
			</Headline>
			<SubTextLine/>
			
			<FindJobButton/>
		
		</Banner.Content>
	
	</Banner.Wrapper>
)

const CareerNewbieHero = (props) =>
	{
		return (
			<ContentContainer>
				
				<HeroBanner/>
			
			</ContentContainer>
		)
	}

export default React.memo(CareerNewbieHero)
